var popularSolutionsData = [
    {
        title: 'SaaS',
        queryKey: 'product',
        queryValue: 'saas'
    },
    {
        title: 'AI + Machine Learning',
        queryKey: 'category',
        queryValue: 'ai-machine-learning'
    },
    {
        title: 'Copilot agents',
        queryKey: 'filters',
        queryValue: 'Copilot-extension'
    },
    {
        title: 'Power Platform',
        queryKey: 'product',
        queryValue: 'power-platform'
    },
    {
        title: 'Microsoft 365',
        queryKey: 'product',
        queryValue: 'office'
    }
];
var prefetchedItemData = popularSolutionsData[0];

export { popularSolutionsData, prefetchedItemData };
